import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { tagsActions } from '../+state/tags.actions';
import { tagsFeature } from '../+state/tags.reducer';
import { selectNotUsedTags, selectTags } from '../+state/tags.selectors';
import { TagType } from '../entities/tags.entity';

@Injectable({ providedIn: 'root' })
export class TagsFacade {
  readonly #store = inject(Store);

  public readonly tags$ = this.#store.select(selectTags);
  public readonly activatedTagIds$ = this.#store.select(tagsFeature.selectActivatedTagIds);
  public readonly notUsedTags$ = this.#store.select(selectNotUsedTags);
  public readonly addTagError$ = this.#store.select(tagsFeature.selectAddTagError);
  public readonly displayAllWithoutTags$ = this.#store.select(tagsFeature.selectDisplayAllItemsWithoutTags);
  public readonly displayTags$ = this.#store.select(tagsFeature.selectDisplayTags);

  public loadTags = (tagType: TagType) => this.#store.dispatch(tagsActions.loadTags({ tagType }));
  public deleteTag = (tagId: string) => this.#store.dispatch(tagsActions.deleteTag({ tagId }));
  public activateAllTags = () => this.#store.dispatch(tagsActions.activateAllTags());
  public activateAllWithoutTags = () => this.#store.dispatch(tagsActions.activateAllWithoutTags());
  public toggleTag = (tagId: string) => this.#store.dispatch(tagsActions.toggleTag({ tagId }));
  public resetTags = () => this.#store.dispatch(tagsActions.resetTags());
  public setEntityId = (entityId: string) => this.#store.dispatch(tagsActions.setCurrentlyEditingEntityId({ entityId }));
  public resetEntityId = () => this.#store.dispatch(tagsActions.resetCurrentlyEditingEntityId());
  public deleteLinkedTag = (tagId: string, entityId: string) => this.#store.dispatch(tagsActions.deleteLinkedTag({ tagId, entityId }));
  public addTag = (tagId: string, entityId: string, name: string) => this.#store.dispatch(tagsActions.addTag({ tagId, entityId, name }));
  public clearErrors = () => this.#store.dispatch(tagsActions.clearErrors());
  public toggleTags = () => this.#store.dispatch(tagsActions.toggleTags());
}
